import { useEffect } from "react";
import gsap from "gsap";

const MainContentAnimations = ({ isLoading }) => {
  useEffect(() => {
    const animations = () => {
      // gsap.to(".container", {
      //   opacity: 1,
      // });
      // gsap.fromTo(
      //   ".mydetail p",
      //   {
      //     opacity: 0,
      //     y: 10,
      //   },
      //   {
      //     opacity: 1,
      //     y: 0,
      //     stagger: 0.1,
      //     duration: 0.6,
      //     ease: "power2.out",
      //     delay: "0.2",
      //   }
      // );
      // gsap.to(".images", {
      //   opacity: 1,
      //   duration: 2,
      //   ease: "power2.inOut",
      //   scaleX: 1,
      //   delay: "0.2",
      // });

      // gsap.fromTo(
      //   ".side-menu, .btn-outline, .logo, .year, .rotating-circle",
      //   {
      //     opacity: 0,
      //   },
      //   {
      //     opacity: 1,
      //     duration: 0.5,
      //     ease: "power2.inOut",
      //     stagger: 0.15,
      //     delay: "0.2",
      //   }
      // );

      gsap.to(".notify", {
        top: "3%",
        left: "0%",
        right: "0%",
        display: "block",
        duration: 1,
        delay: "5",
      });
    };

    // Run animations only if not loading
    if (!isLoading) {
      animations();
    }
  }, [isLoading]);

  return null; // This component doesn't render anything
};

export default MainContentAnimations;
